<template>
  <div>
    <transition name="route" mode="out-in">
      <PreLoader v-if="allIsLoading && this.$route.name === 'AboutUs'" />
    </transition>
    <div
      class="welcome-img-about-us_Page"
      v-if="this.$route.name === 'AboutUs'"
    >
      <img
        :src="bannerPath"
        alt=""
        class="full-width max-height"
        loading="lazy"
      />
    </div>
    <div class="section-about-us">
      <div class="container">
        <div class="row" v-if="this.$route.name === 'AboutUs'">
          <div class="col-md-12">
            <h1 class="title text-center mb-5">We are The Ear</h1>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="about-content">
              <h3
                class="text-center FirstLook-text"
                v-if="this.$route.name === 'AboutUs'"
              >
                Our Brand
              </h3>
              <p v-if="this.$route.name === 'AboutUs'">
                <b>The Ear </b> offers a comprehensive Aggregation gaming
                platform, licensed in
                <strong>several jurisdictions</strong> worldwide and adapted for
                major 3rd party games and products. The platform's active
                intuitive user and game bonus management functionality,
                extensive analytics, and reporting tools integrated with a
                portfolio of over 130 of the
                <strong>primary game providers</strong> in the industry.
                <b
                  >The Ear provides tailored technology solutions to meet the
                  needs pf B2C Operators and B2B providers.</b
                >
              </p>
              <h3 class="text-center FirstLook-text">About Us</h3>
              <p>
                With over <b>20 years of experience</b> as a gaming operator,
                <b>The Ear </b> has been estabilished and evolved to become a
                sought-after iGaming software provider for various other
                operators in the industry.
              </p>
              <p>
                The several years of experience in risk management, odds
                compiling, multiple profitable campaigns, and customer care
                forms the core foundation of <b>The Ear is</b> designed for both
                Operator, either online or land-based and for B2B providers as
                <strong>we understand the technology required</strong> in this
                competitive market.
              </p>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 col-xs-12 text-center testClass">
            <img
              class="about-us-icon"
              loading="lazy"
              :src="publicPath + 'assets/images/api.png'"
              alt="Slots, Live Casino, Bingo, Virtual Sports, Sportsbetting &amp; More all via One Single API"
            />
            <p>
              Slots, Live Casino, Bingo &amp; more with one Single API
              <!-- &amp; More all via One Single API -->
            </p>
          </div>
          <div class="col-md-3 col-sm-6 col-xs-12 text-center testClass">
            <img
              class="about-us-icon"
              :src="publicPath + 'assets/images/license.png'"
              alt="Certified and licensed in over 20 jurisdictions"
              loading="lazy"
            />
            <p>Certified and licensed</p>
          </div>
          <div class="col-md-3 col-sm-6 col-xs-12 text-center testClass">
            <img
              class="about-us-icon"
              :src="publicPath + 'assets/images/award.png'"
              alt="We Love Responsive"
              loading="lazy"
            />
            <p>Mobile, desktop, tablet.<br />We Love Responsive</p>
          </div>
          <div class="col-md-3 col-sm-6 col-xs-12 text-center testClass">
            <img
              class="about-us-icon"
              :src="publicPath + 'assets/images/language.png'"
              alt=" multi-languages and all currencies"
              loading="lazy"
            />
            <p>
              Multi-languages<br />
              and all currencies
            </p>
          </div>
        </div>
      </div>
      <OurServices v-if="this.$route.name === 'AboutUs'" />
      <OurPartner v-if="this.$route.name === 'AboutUs'" />
      <WhyUs v-if="this.$route.name === 'AboutUs'" />
    </div>
  </div>
</template>

<script>
import OurServices from "@/components/UI/OurServices.vue";
import OurPartner from "@/components/UI/OurPartner.vue";
import WhyUs from "@/components/UI/WhyUs.vue";
import PreLoader from "@/components/Global/PreLoader.vue";

export default {
  name: "AboutUs",
  components: {
    OurServices,
    OurPartner,
    WhyUs,
    PreLoader,
  },
  data() {
    return {
      lang: localStorage.getItem("language") ?? "en",
      allIsLoading: true,
      bannerPath: "",
      publicPath: process.env.VUE_APP_PUBLIC_PATH ?? "/",
    };
  },
  methods: {
    timeout() {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      setTimeout(() => {
        document.body.style.overflow = "";
        document.documentElement.style.overflow = "";
        this.allIsLoading = false;
      }, 1500);
    },
    setBannerPath() {
      if (window.innerWidth <= 600) {
        this.bannerPath =
          this.publicPath +
          "assets/images/CaroselloBanner/about_banner_mobile.png";
      } else {
        this.bannerPath =
          this.publicPath + "assets/images/CaroselloBanner/about_banner.png";
      }
    },
    setMetaTags() {
      const title = "The Ear | About Us";
      const metaDescription =
        "The Ear stands as a prominent rising star among slot providers within the ever-expanding realm of online gaming. Dive deeper into our story and offerings to uncover the full extent of our journey!";
      if (this.$route.name === "AboutUs") {
        document.title = title;

        const metaDescriptionTag = document.querySelector(
          'meta[name="description"]'
        );
        if (metaDescriptionTag) {
          metaDescriptionTag.setAttribute("content", metaDescription);
        } else {
          const newMetaTag = document.createElement("meta");
          newMetaTag.name = "description";
          newMetaTag.content = metaDescription;
          document.head.appendChild(newMetaTag);
        }
      }
    },
  },
  created() {
    document.body.style.fontFamily = "Poppins, sans-serif";
    this.setMetaTags();
    this.setBannerPath();
    this.timeout();
  },
  mounted() {
    window.addEventListener("resize", this.setBannerPath);
  },
};
</script>

<style scoped>
.welcome-img-about-us_Page {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.testClass {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
/* .welcome-img-about-us_Page {
  padding: 85px 0px 0px;
} */
.full-width {
  width: 100%;
}
.max-height {
  max-height: 90vh;
  max-width: 100%;
  object-fit: cover;
}

.section-about-us {
  /* padding: 40px 0; */
  padding: 0px 0px 40px 0px;
}
.container {
  padding: 40px 0px 0px 0px;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
}

.row {
  margin-right: -15px;
  margin-left: -15px;
}

.row:after,
.row:before {
  display: table;
  content: " ";
}

.row:after {
  clear: both;
}
.container .col-md-12 {
  padding-left: 0;
}

.container .about-content {
  margin-top: 20px;
}

.container .title {
  font-size: 40px;
  font-weight: 600;
  line-height: 1.25;
  letter-spacing: 1px;
  text-align: center;
  color: #160f1d;
}

.container img {
  min-height: 100px;
}

.container p {
  margin-top: 15px;
  margin-bottom: 40px;
  font-size: 16px;
  line-height: 1.75;
  text-align: center;
  color: #160f1d;
  min-height: 75px;
}

.FirstLook-text {
  font-weight: 600;
  color: cornflowerblue;
}

.about-us-icon {
  /* max-width: 100px;
  max-height: 100px;
  object-fit: contain;
  aspect-ratio: 4/3; */
  max-width: 100px;
  max-height: 100px;
  object-fit: fill;
  aspect-ratio: 4/3;
}

@media (max-width: 992px) {
  .container {
    padding: 20px 30px;
  }

  .container .title {
    font-size: 30px;
    font-weight: 600;
    line-height: 1.25;
    letter-spacing: 1px;
    text-align: center;
    color: #160f1d;
  }
}

@media (max-width: 767px) {
  .testClass {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    flex: 1 1 50%;
  }
}

@media (max-width: 600px) {
  .container p {
    margin-top: 15px;
    margin-bottom: 40px;
    font-size: 16px;
    line-height: 1.75;
    text-align: center;
    color: #160f1d;
    min-height: 60px;
  }
}
</style>
